import React, { Fragment, ReactElement } from 'react';
import { Box, Grid, Button, Paper, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import TranslatedText from '../../../../components/atoms/translated_text';
import useStyles from './styles';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';
import useQuery from 'custom_hooks/useQuery';
import { Translations } from '../../configuration';
import clsx from 'clsx';
import KPI from './kpi';
import AdminDashboardActions from 'redux/reducers/admin_dashboard_reducer/actions';
import * as AdminDashboardSelectors from '../../../../redux/reducers/admin_dashboard_reducer/selectors';

import Filter from '../filterScheme';

import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';

export default function AdminKPIs(): ReactElement {
  const ROLE = AuthSelectors.useSelectUserRole();
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const schemeType = query.get('schemeType');
  const periodLength = query.get('periodLength');

  // let searchParams = {
  //   ...(schemeType && { schemeType }),
  //   ...(periodLength && { periodLength }),
  // };

  // React.useEffect(() => {
  //   dispatch(
  //     AdminDashboardActions.fetchAdminDashboardDataAction({
  //       ...searchParams,
  //     })
  //   );
  // }, [dispatch, searchParams]);

  const adminDashboardData =
    AdminDashboardSelectors.useGetAdminDashboardData().data;

  return (
    <Fragment>
      <Grid container alignItems="flex-start" spacing={2}>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Registered Users'}
              description={'Total number of registered users'}
              color={'green'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.registeredUsers
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalUsers > 0
                  ? (adminDashboardData.adminKPIs.registeredUsers /
                      adminDashboardData.adminKPIs.totalUsers) *
                    100
                  : 0
              }
              iconName={'verifiedUsers'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Not Verified Users'}
              description={'Total number of not verified users'}
              color={'orange'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.notVerifiedUsers
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalUsers > 0
                  ? (adminDashboardData.adminKPIs.notVerifiedUsers /
                      adminDashboardData.adminKPIs.totalUsers) *
                    100
                  : 0
              }
              iconName={'notVerifiedUsers'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Messages with Errors'}
              description={'Incoming messages with errors'}
              color={'red'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.incomingMessagesWithErrors
                  : 0
              }
              barPercentage={100}
              iconName={'incomingMessageErrors'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Technical Error Messages'}
              description={'Total number of technical error messages received'}
              color={'red'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.technicalErrorMessages
                  : 0
              }
              barPercentage={100}
              iconName={'technicalErrorMessages'}
              showBar={true}
            />
          </div>
        </Row>

        {(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
          <Row widthInLargeScreen={12} widthInMidScreen={12}>
            <Filter
              schemeType={schemeType}
              periodLength={periodLength}
              role={ROLE}
              filters={adminDashboardData?.filters}
            />
          </Row>
        )}

        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Active Registrations'}
              description={
                'Total number of active registrations that have been approved'
              }
              color={'green'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.activeRegistrations
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalRegistrations > 0
                  ? (adminDashboardData.adminKPIs.activeRegistrations /
                      adminDashboardData.adminKPIs.totalRegistrations) *
                    100
                  : 0
              }
              iconName={'activeRegistrations'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Excluded Registrations'}
              description={
                'Total number of active registrations that have been excluded'
              }
              color={'orange'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.excludedRegistrations
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalRegistrations > 0
                  ? (adminDashboardData.adminKPIs.excludedRegistrations /
                      adminDashboardData.adminKPIs.totalRegistrations) *
                    100
                  : 0
              }
              iconName={'excludedRegistrations'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'New Registrations'}
              description={
                'Total number of new registrations pending for approval'
              }
              color={'blue'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.newRegistrations
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalRegistrations > 0
                  ? (adminDashboardData.adminKPIs.newRegistrations /
                      adminDashboardData.adminKPIs.totalRegistrations) *
                    100
                  : 0
              }
              iconName={'newRegistrations'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Update Requests'}
              description={'Total number of update requests for registrations'}
              color={'purple'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.updateRequests
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalRegistrations > 0
                  ? (adminDashboardData.adminKPIs.updateRequests /
                      adminDashboardData.adminKPIs.totalRegistrations) *
                    100
                  : 0
              }
              iconName={'updateRequests'}
              showBar={true}
            />
          </div>
        </Row>
        {/*(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
          <Row widthInLargeScreen={12} widthInMidScreen={12}>
            <FilterYears periodLength={periodLength} role={ROLE} />
          </Row>
        )*/}
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Active VAT Returns'}
              description={'Total number of active VAT returns'}
              color={'green'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.activeVatReturns
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalVatReturns > 0
                  ? (adminDashboardData.adminKPIs.activeVatReturns /
                      adminDashboardData.adminKPIs.totalVatReturns) *
                    100
                  : 0
              }
              iconName={'activeVatReturns'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'New VAT Returns'}
              description={'Total number of new and temporary VAT returns'}
              color={'blue'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.newVatReturns
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalVatReturns > 0
                  ? (adminDashboardData.adminKPIs.newVatReturns /
                      adminDashboardData.adminKPIs.totalVatReturns) *
                    100
                  : 0
              }
              iconName={'newVatReturns'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'Submitted VAT Returns'}
              description={
                'Total number of submitted VAT returns pending for approval'
              }
              color={'blue'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.submittedVatReturns
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalVatReturns > 0
                  ? (adminDashboardData.adminKPIs.submittedVatReturns /
                      adminDashboardData.adminKPIs.totalVatReturns) *
                    100
                  : 0
              }
              iconName={'submittedVatReturns'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={3} widthInMidScreen={4}>
          <div>
            <KPI
              name={'VAT Returns with Errors'}
              description={'Total number of VAT returns with errors'}
              color={'red'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.vatReturnsWithErrors
                  : 0
              }
              barPercentage={
                adminDashboardData &&
                adminDashboardData.adminKPIs &&
                adminDashboardData.adminKPIs.totalVatReturns > 0
                  ? (adminDashboardData.adminKPIs.vatReturnsWithErrors /
                      adminDashboardData.adminKPIs.totalVatReturns) *
                    100
                  : 0
              }
              iconName={'vatReturnsWithErrors'}
              showBar={true}
            />
          </div>
        </Row>

        <Row widthInLargeScreen={6} widthInMidScreen={6}>
          <div>
            <KPI
              name={'VAT Amount Declared'}
              description={'Total VAT amount that has been declared'}
              color={'blue'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.vatAmountDeclared
                  : 0
              }
              barPercentage={0}
              iconName={'vatAmountDeclared'}
              showBar={false}
              chart={
                adminDashboardData?.vatAmountDeclaredAnalytics
                  ? adminDashboardData.vatAmountDeclaredAnalytics
                  : undefined
              }
            />
          </div>
        </Row>
        <Row widthInLargeScreen={6} widthInMidScreen={6}>
          <div>
            <KPI
              name={'Payable Amount'}
              description={'Total amount that is payable'}
              color={'blue'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.payableAmount
                  : 0
              }
              barPercentage={0}
              iconName={'payableAmount'}
              showBar={false}
              chart={
                adminDashboardData?.payableAmountAnalytics
                  ? adminDashboardData.payableAmountAnalytics
                  : undefined
              }
            />
          </div>
        </Row>
        <Row widthInLargeScreen={6} widthInMidScreen={6}>
          <div>
            <KPI
              name={'Amount Paid'}
              description={'Total amount paid'}
              color={'green'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.amountPaid
                  : 0
              }
              barPercentage={0}
              iconName={'amountPaid'}
              showBar={false}
              chart={
                adminDashboardData?.amountPaidAnalytics
                  ? adminDashboardData.amountPaidAnalytics
                  : undefined
              }
            />
          </div>
        </Row>
        <Row widthInLargeScreen={6} widthInMidScreen={6}>
          <div>
            <KPI
              name={'Amount Allocated'}
              description={'Total amount that has been allocated'}
              color={'orange'}
              value={
                adminDashboardData && adminDashboardData.adminKPIs
                  ? adminDashboardData.adminKPIs.amountAllocated
                  : 0
              }
              barPercentage={0}
              iconName={'amountAllocated'}
              showBar={false}
              chart={
                adminDashboardData?.amountAllocatedAnalytics
                  ? adminDashboardData.amountAllocatedAnalytics
                  : undefined
              }
            />
          </div>
        </Row>
      </Grid>
    </Fragment>
  );
}

interface IRowProps {
  widthInLargeScreen: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  widthInMidScreen: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  children: ReactElement;
}

const Row = (props: IRowProps): ReactElement => {
  return (
    <Grid
      xl={props.widthInLargeScreen}
      lg={props.widthInLargeScreen}
      md={props.widthInMidScreen}
      xs={12}
      sm={12}
      item
    >
      {props.children}
    </Grid>
  );
};
